import { acquireBodyScrollLock, releaseBodyScrollLock } from './bodyScrollLock.js';

(function () {
    // Intentionally imported for side effects: SSR preview markup initialises
    // these window.fileviewer* hooks via declarative data-needs-init attributes.
    // Do not remove or refactor away these global bindings.
    function notify(message) {
        if (typeof window.showFlashMessage === 'function') {
            window.showFlashMessage(null, 'warning', message, 5);
            return;
        }
        window.alert(message);
    }

    function setHtmlPreviewReadyState(isReady) {
        var loading = document.getElementById('fileviewer-html-preview-loading');
        var iframe = document.getElementById('fileviewer-html-preview-frame');
        var actions = document.querySelectorAll('[data-preview-action="html"]');

        if (loading) loading.classList.toggle('hidden', isReady);
        if (iframe) iframe.classList.toggle('opacity-0', !isReady);
        actions.forEach(function (button) {
            button.disabled = !isReady;
            button.classList.toggle('opacity-50', !isReady);
            button.classList.toggle('cursor-not-allowed', !isReady);
        });
    }

    function exportHtmlTablesToExcel(container, filename) {
        var clone = container.cloneNode(true);
        clone.querySelectorAll('img, style, script').forEach(function (el) { el.remove(); });

        var tables = clone.querySelectorAll('table');
        var wb = XLSX.utils.book_new();

        if (!tables.length) {
            var emptySheet = XLSX.utils.aoa_to_sheet([['No tabular data found in the preview.']]);
            XLSX.utils.book_append_sheet(wb, emptySheet, 'Sheet1');
            XLSX.writeFile(wb, filename);
            return;
        }

        var allRows = [];
        var ownerDoc = clone.ownerDocument || document;
        var nodeFilter = ownerDoc.defaultView && ownerDoc.defaultView.NodeFilter
            ? ownerDoc.defaultView.NodeFilter
            : NodeFilter;

        var firstTable = tables[0];
        var walker = ownerDoc.createTreeWalker(clone, nodeFilter.SHOW_ELEMENT);
        var node;
        while ((node = walker.nextNode())) {
            if (node === firstTable) break;
            var tag = node.tagName;
            if (['DIV', 'SPAN', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].indexOf(tag) !== -1) {
                var text = (node.textContent || '').trim();
                if (text && node.children.length === 0) allRows.push([text]);
            }
        }
        if (allRows.length > 0) allRows.push([]);

        tables.forEach(function (table, idx) {
            var caption = table.querySelector('caption');
            if (caption) {
                allRows.push([]);
                allRows.push([(caption.textContent || '').trim()]);
            }
            var ws = XLSX.utils.table_to_sheet(table, { raw: true });
            var aoa = XLSX.utils.sheet_to_json(ws, { header: 1 });
            aoa.forEach(function (row) { allRows.push(row); });
            if (idx < tables.length - 1) allRows.push([]);
        });

        var lastTable = tables[tables.length - 1];
        var afterLastTable = false;
        var walker2 = ownerDoc.createTreeWalker(clone, nodeFilter.SHOW_ELEMENT);
        while ((node = walker2.nextNode())) {
            if (node === lastTable) { afterLastTable = true; continue; }
            if (!afterLastTable) continue;
            if (node.closest && node.closest('table')) continue;
            var tag2 = node.tagName;
            if (['DIV', 'SPAN', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].indexOf(tag2) !== -1) {
                var text2 = (node.textContent || '').trim();
                if (text2 && node.children.length === 0) allRows.push([text2]);
            }
        }

        var sheet = XLSX.utils.aoa_to_sheet(allRows);
        XLSX.utils.book_append_sheet(wb, sheet, 'Sheet1');
        XLSX.writeFile(wb, filename);
    }

    var _fileviewerHoldsScrollLock = false;

    window.fileviewerLockBodyScroll = function () {
        if (_fileviewerHoldsScrollLock) return;
        _fileviewerHoldsScrollLock = true;
        acquireBodyScrollLock();
    };

    function unlockBodyScroll() {
        if (!_fileviewerHoldsScrollLock) return;
        _fileviewerHoldsScrollLock = false;
        releaseBodyScrollLock();
    }

    window.fileviewerCloseBackdrop = function (el) {
        if (el.dataset.boundFileviewerCloseBackdrop) return;
        el.dataset.boundFileviewerCloseBackdrop = '1';
        el.addEventListener('click', function () {
            window.closeModal('fileviewer');
            unlockBodyScroll();
        });
    };

    window.fileviewerDownloadFile = function (el) {
        if (el.dataset.boundFileviewerDownload) return;
        el.dataset.boundFileviewerDownload = '1';
        el.addEventListener('click', async function () {
            var filelink = el.getAttribute('data-filelink');
            if (!filelink) { notify('Download failed: no file link provided.'); return; }
            try {
                var res = await fetch(filelink);
                if (!res.ok) { notify('Download failed'); return; }
                var blob = await res.blob();
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.classList.add('hidden');
                a.href = url;
                var rawName = filelink.split('/').pop().split('?')[0];
                var decodedName;
                try { decodedName = decodeURIComponent(rawName); } catch (_e) { decodedName = rawName; }
                a.download = decodedName || 'file';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            } catch (e) {
                notify('Download failed: ' + (e && e.message ? e.message : String(e)));
            }
        });
    };

    window.fileviewerInitHtmlFrame = function (iframe) {
        if (iframe.dataset.boundPreview) return;
        iframe.dataset.boundPreview = '1';
        setHtmlPreviewReadyState(false);
        try {
            var readyState = iframe.contentDocument && iframe.contentDocument.readyState;
            if (readyState === 'complete') {
                setHtmlPreviewReadyState(true);
                return;
            }
        } catch (_e) {}
        iframe.addEventListener('load', function () {
            setHtmlPreviewReadyState(true);
        }, { once: true });
    };

    window.fileviewerExportHtmlPreviewToExcel = function (button) {
        try {
            if (typeof XLSX === 'undefined') {
                notify('Excel export library not available. Please refresh and try again.');
                return;
            }

            var iframeId = button && button.getAttribute('data-iframe-id');
            var iframe = iframeId ? document.getElementById(iframeId) : null;
            if (!iframe) { notify('Preview frame not found.'); return; }

            var frameDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
            if (!frameDoc || !frameDoc.body) {
                notify('Preview is still loading. Please try again.');
                return;
            }

            var filelink = button.getAttribute('data-filelink') || '';
            var baseName = 'preview';
            if (filelink) {
                try {
                    var parsed = new URL(filelink, window.location.origin);
                    var lastPart = (parsed.pathname.split('/').pop() || '').trim();
                    if (lastPart) baseName = lastPart;
                } catch (_e) {}
            }
            if (!/\.xlsx$/i.test(baseName)) baseName = baseName.replace(/\.[^.]+$/, '') + '.xlsx';

            button.disabled = true;
            button.classList.add('opacity-50', 'cursor-not-allowed');
            exportHtmlTablesToExcel(frameDoc.body, baseName);
        } catch (error) {
            notify('Excel export failed. Please try again.');
        } finally {
            if (button) {
                button.disabled = false;
                button.classList.remove('opacity-50', 'cursor-not-allowed');
            }
        }
    };

    window.fileviewerPrintHtmlPreview = function (button) {
        try {
            var iframeId = button && button.getAttribute('data-iframe-id');
            var iframe = iframeId ? document.getElementById(iframeId) : null;
            if (!iframe || !iframe.contentWindow) { notify('Preview frame not found.'); return; }
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        } catch (error) {
            notify('Print failed. Please try again.');
        }
    };

    window.fileviewerExcelBtnInit = function (btn) {
        if (btn.dataset.boundFileviewerExcel) return;
        btn.dataset.boundFileviewerExcel = '1';
        btn.addEventListener('click', function () { window.fileviewerExportHtmlPreviewToExcel(btn); });
    };

    window.fileviewerPrintBtnInit = function (btn) {
        if (btn.dataset.boundFileviewerPrint) return;
        btn.dataset.boundFileviewerPrint = '1';
        btn.addEventListener('click', function () { window.fileviewerPrintHtmlPreview(btn); });
    };
})();
